// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#footer[data-v-3c6d0a68] {position:sticky;bottom:0;z-index:10}#footer[data-v-3c6d0a68]  .bg-transparent{background:hsla(0,0%,100%,.8);-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px)}@media(max-width:576px){#footer[data-v-3c6d0a68] {bottom:10px}}", ""]);
// Exports
module.exports = exports;
